import { useEffect, useRef, useCallback, useState, forwardRef, ForwardRefRenderFunction } from 'react'
import ToastComponent from '@/components/Toast/Toast'
import { Toast } from '@/hooks/useToast'
import { Timer } from './utils'
import { DEFAULT_TIMEOUT } from './settings'

interface Props {
  remove: (id: string) => void
  toast: Toast
  transitionState: string
}

const ToastController: ForwardRefRenderFunction<any, Props> = ({ remove, toast, transitionState }: Props, ref) => {
  const timer = useRef(null)
  const [isRunning, setRunning] = useState(true)

  useEffect(() => {
    const { options: { duration } } = toast
    const currentTimer = new Timer(() => remove(toast.id), duration || DEFAULT_TIMEOUT)
    timer.current = currentTimer
    return () => currentTimer.clear()
  }, [toast, remove])

  const onMouseOver = useCallback(() => {
    setRunning(false)
  }, [setRunning])

  const onMouseLeave = useCallback(() => {
    setRunning(true)
  }, [setRunning])

  useEffect(() => {
    if (isRunning) {
      timer.current?.resume()
    } else {
      timer.current?.pause()
    }
  }, [isRunning])

  const { onDismiss, duration, ...rest } = toast.options

  return (
    <ToastComponent
      ref={ref}
      transitionState={transitionState}
      {...rest}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    />
  )
}

export default forwardRef(ToastController)
